import { Link, useNavigate } from 'react-router-dom';
import { ShoppingBag, Search, Sun, Moon, Menu, ShoppingCart } from 'lucide-react';
import { useState, useRef, useEffect } from 'react';
import { useStore } from '@/store';
import { useStoreInfo } from '@/lib/store';
import { resolveImageUrl } from '@/lib/utils';

export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const cart = useStore((state) => state.cart);
  const darkMode = useStore((state) => state.darkMode);
  const toggleDarkMode = useStore((state) => state.toggleDarkMode);
  const { storeInfo } = useStoreInfo();
  const navigate = useNavigate();

  const navigation = [
    { name: 'Home', href: '/home' },
    { name: 'Products', href: '/products' },
    { name: 'Track Order', href: '/track' },
    { name: 'Wishlist', href: '/wishlist' },
    { name: 'FAQ', href: '/faq' },
    { name: 'About Us', href: '/about' },
    { name: 'Contact Us', href: '/contact' },
  ];

  return (
    <header className="sticky top-0 z-50 bg-white dark:bg-gray-800 shadow-sm">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between gap-8">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              {storeInfo?.site_logo ? (
                <img 
                  src={resolveImageUrl(storeInfo.site_logo)} 
                  alt={storeInfo.site_name} 
                  className="h-8 w-auto"
                />
              ) : (
                <>
                  <ShoppingCart className="h-8 w-8 text-brand-primary" />
                  <span className="text-xl font-display font-bold text-brand-primary">
                    D & D African
                  </span>
                </>
              )}
            </Link>
          </div>

          <nav className="hidden lg:flex lg:flex-1 lg:items-center lg:justify-center">
            <ul className="flex space-x-8">
              {navigation.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-gray-700 hover:text-brand-primary dark:text-gray-300 dark:hover:text-brand-light transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/products')}
              className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              <Search className="h-5 w-5 text-gray-500 dark:text-gray-400" />
            </button>

            <button
              onClick={toggleDarkMode}
              className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              {darkMode ? (
                <Sun className="h-5 w-5 text-gray-500 dark:text-gray-400" />
              ) : (
                <Moon className="h-5 w-5 text-gray-500" />
              )}
            </button>

            <Link to="/cart" className="relative p-2">
              <ShoppingBag className="h-5 w-5 text-gray-500 dark:text-gray-400" />
              {cart.length > 0 && (
                <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-brand-primary text-[10px] text-white">
                  {cart.length}
                </span>
              )}
            </Link>

            <button
              onClick={() => setIsOpen(!isOpen)}
              className="lg:hidden p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              <Menu className="h-5 w-5 text-gray-500 dark:text-gray-400" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="lg:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-brand-primary hover:bg-gray-50 dark:text-gray-300 dark:hover:text-brand-light dark:hover:bg-gray-700"
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
